import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DEFAULT_PER_PAGE, SECTORS, SHIPPING_TYPE_VALUES } from "../constants";
import {
  AppliedSectorEmailsFilters,
  FilterStateSectorEmails,
  SectorEmailsPagination,
  SectorEmailsSorting,
} from "./types";

const INITIAL_STATE: FilterStateSectorEmails = {
  filters: {
    search: "",
    active: [true, false],
    sectors: [...SECTORS],
    shipping_types: [...SHIPPING_TYPE_VALUES],
    meta: { page: 1, perPage: DEFAULT_PER_PAGE },
    sorting: {},
  },
};

const sectorEmailsFilterSlice = createSlice({
  name: "sectorEmailsFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setSectorEmailsSearch(state, action: PayloadAction<string>) {
      state.filters.search = action.payload;
      state.filters.meta.page = 1;
    },
    setSectorEmailsPagination(
      state,
      action: PayloadAction<SectorEmailsPagination>
    ) {
      state.filters.meta = action.payload;
    },
    applySectorEmailsFilters(
      state,
      action: PayloadAction<AppliedSectorEmailsFilters>
    ) {
      state.filters.active = action.payload.active;
      state.filters.sectors = action.payload.sectors;
      state.filters.shipping_types = action.payload.shipping_types;
      state.filters.meta.page = 1;
    },
    setSectorEmailsSorting(state, action: PayloadAction<SectorEmailsSorting>) {
      state.filters.sorting = action.payload;
      state.filters.meta.page = 1;
    },
    resetSectorEmailsFilters(state) {
      state.filters = {
        ...INITIAL_STATE.filters,
        search: state.filters.search,
        meta: { page: 1, perPage: state.filters.meta.perPage },
        sorting: state.filters.sorting,
      };
    },
  },
});

export const {
  setSectorEmailsSearch,
  setSectorEmailsPagination,
  setSectorEmailsSorting,
  applySectorEmailsFilters,
  resetSectorEmailsFilters,
} = sectorEmailsFilterSlice.actions;

export default sectorEmailsFilterSlice.reducer;
